import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Optional, Inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { datePickerMinDate, isSCCase } from '../../shared/constants';
import * as FileSaver from 'file-saver';
import { NavbarComponent } from '../../navbar/navbar.component';
declare const $: any;
@Component({
	selector: 'app-list-appointment',
	templateUrl: './list-appointment.component.html',
	styleUrl: './list-appointment.component.scss'
})
export class ListAppointmentComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	/* showLinkLoader: any = null; */
	showLinkLoader = false;
	pagetitle = "Appointment List";
	companyList: any[] = [];
	hospitalList: any[] = [];
	doctorList: any[] = [];
	followUpStatusList: any[] = [];
	caseStatusList: any[] = [
		{ id: 1, name: "Open" },
		{ id: 2, name: "Closed" },
	];
	filters: any = {
		hospital: null,
		company: null,
		doctor: null,
		followup_status: null,
		case_status: null,
		case_category: null,
		from_date: null,
		to_date: null,
		physiotherapy: false,
		upcoming_arrival: false,
		not_replied: false
	};
	minDate = datePickerMinDate;
	isSCCase = isSCCase;
	allCaseCategories: any[] = [];
	caseExcelLoader = false;
	searchVal: any = null;
	user: any = null;
	mailList: any[] = [];
	mailLoading = false;
	mailsParam: any;
	caseOpenStatusId = 1;
	caseClosedStatusId = 2;

	constructor(private router: Router, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void {
		this.activeRoute.queryParams.subscribe(params => {
			if (params["mails"]) {
				this.mailsParam = params["mails"];
				this.breadcrumbList.push({ path: "/app/mailbox/folder/unlinked", name: "Mailbox" });
				this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List", params: { mails: this.mailsParam } });
				const mailIds = params["mails"].split("-");
				this.getMails(mailIds);
				this.initComp();
			} else if (params["filter"]) {
				if (params["filter"] == "Open") {
					this.filters.case_status = this.caseOpenStatusId;
				} else if (params["filter"] == "Closed") {
					this.filters.case_status = this.caseClosedStatusId;
				} else if (params["filter"] == "Physiotherapy") {
					this.filters.physiotherapy = true;
					this.physiotherapyChanged();
				} else if (params["filter"] == "UpcomingArrivals") {
					this.filters.upcoming_arrival = true;
				} else if (params["filter"] == "NotReplied") {
					this.filters.not_replied = true;
				}
				this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List" });
				this.initComp();
			} else {
				this.breadcrumbList.push({ path: "/app/list-appointment", name: "Appointment List" });
				this.initComp();
			}
		});
	}

	initComp() {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.user = user;
				this.initDatatable();
				this.getCompanyList();
				this.getHospitalList();
				/* this.getDoctorList(); */
				this.getAllFollowUpStatus();
				this.getCaseCatList();
			}
		});
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.getDoctorList();
			}
		})
	}

	ngOnDestroy(): void { }

	ngAfterViewInit(): void { }

	getMails(mailIds: any[]) {
		this.mailLoading = true;
		this.apiService.getMultipleMail(mailIds).subscribe({
			next: (response: any) => {
				this.mailLoading = false;
				this.mailList = response;
			}, error: (error) => {
				this.mailLoading = false;
				this.mailList = [];
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	/* linkMails(caseObj: any) {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to link case <strong>' + caseObj.case_id + '</strong> ?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				const payload = {
					"event_id": caseObj.id,
					"mail_ids": this.mailList.map((c) => c.id)
				}
				this.showLinkLoader = caseObj.id;
				this.apiService.linkMail(payload).subscribe({
					next: (response: any) => {
						this.showLinkLoader = null;
						this.toastr.success("Case linked successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.router.navigate(['/app/appt-details','no', caseObj.enc_id, 'empty']);
					}, error: (error) => {
						this.showLinkLoader = null;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	} */

	linkMails() {
		if (!this.selectedCaseIds.length) {
			this.toastr.error("No case selected", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to link selected case(s)?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				const payload = {
					"event_id": this.selectedCaseIds,
					"mail_ids": this.mailList.map((c) => c.id)
				}
				this.showLinkLoader = true;
				this.apiService.linkMail(payload).subscribe({
					next: (response: any) => {
						this.showLinkLoader = false;
						this.toastr.success("Case linked successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.router.navigate(['/app/mailbox/folder/unlinked']);
					}, error: (error) => {
						this.showLinkLoader = false;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	selectedCaseIds: any[] = [];
	checked_unchecked(caseObj: any) {
		if (caseObj.selected) {
			this.selectedCaseIds.push(caseObj.id);
		} else {
			this.selectedCaseIds = this.selectedCaseIds.filter(item => item !== caseObj.id);
		}
	}

	physiotherapyChanged() {
		if (this.filters.physiotherapy) {
			this.filters.case_status = this.caseOpenStatusId;
		}
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: ['search'],
				bottomStart: ['info'],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				this.searchVal = dataTablesParameters.search.value;
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value,
					usertype: this.user.usertype,
					...this.getAdvancedSearch()
				}
				this.apiService.getCase(data).subscribe({
					next: (response: any) => {
						let len = response.data.length;
						for (let i = 0; i < len; i++) {
							if (this.selectedCaseIds.includes(response.data[i].id)) {
								response.data[i].selected = true;
							}
						}
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						if (error.status == 404) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getAdvancedSearch() {
		let data: any = {};
		if (this.filters.hospital) {
			data["hospital"] = this.filters.hospital;
		}
		if (this.filters.company) {
			data["company"] = this.filters.company;
		}
		if (this.filters.doctor) {
			data["doctor"] = this.filters.doctor;
		}
		if (this.filters.followup_status) {
			data["followup_status"] = this.filters.followup_status;
		}
		if (this.filters.case_status) {
			data["case_status"] = this.filters.case_status;
		}
		if (this.filters.case_category) {
			data["case_category"] = this.filters.case_category;
		}
		if (this.filters.from_date) {
			data["from_date"] = this.apiService.getDateStringFromDate(this.filters.from_date);
		}
		if (this.filters.to_date) {
			data["to_date"] = this.apiService.getDateStringFromDate(this.filters.to_date);
		}
		if (this.filters.physiotherapy) {
			data["physiotherapy"] = this.filters.physiotherapy;
		}
		if (this.filters.upcoming_arrival) {
			data["upcoming_arrival"] = this.filters.upcoming_arrival;
		}
		if (this.filters.not_replied) {
			data["isReplied"] = false;
		}
		return data;
	}

	deleteConfirm(caseObj: any) {
		if (!this.isSCCase(caseObj.case_id)) {
			this.toastr.warning("Cases linked with HC cannot be deleted.", 'HC Case', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = caseObj.id;
				this.apiService.deleteCase({ id: caseObj.enc_id }).subscribe({
					next: (response: any) => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	getCompanyList() {
		this.apiService.getCompany({}).subscribe({
			next: (data: any) => {
				this.companyList = data.data;
			}, error: (error) => {
				this.companyList = [];
			},
		});
	}

	getHospitalList() {
		this.apiService.getHospital({}).subscribe({
			next: (data: any) => {
				this.hospitalList = data.data;
			}, error: (error) => {
				this.hospitalList = [];
			},
		});
	}

	getDoctorList() {
		this.filters.doctor = null;
		/* let payload: any = {};
		if (this.filters.hospital) {
			payload["id"] = this.filters.hospital;
		}
		this.apiService.getDoctorList(payload).subscribe({
			next: (data: any) => {
				this.doctorList = [...data.data];
			}, error: (error) => {
				this.doctorList = [];
			},
		}); */
		this.doctorList = this.navbar.filterDoctors(this.filters.hospital);
	}

	getAllFollowUpStatus() {
		this.apiService.getAllFollowUpStatus().subscribe({
			next: (data: any) => {
				let groupedData = data.data.reduce((prev: any, current: any) => {
					const key = current.category;
					if (!prev[key]) {
						prev[key] = [];
					}
					prev[key].push(current);
					return prev;
				}, {});
				this.followUpStatusList = groupedData.FollowUp;
			}, error: (error) => {
				this.followUpStatusList = [];
			},
		});
	}

	getCaseCatList() {
		this.apiService.getAllCaseCategories().subscribe({
			next: (data: any) => {
				this.allCaseCategories = [{ id: "unassigned", name: "Unassigned" }, ...data];
			}, error: (error) => {
				this.allCaseCategories = [];
			},
		});
	}

	getExcel() {
		let payload: any = {
			...this.getAdvancedSearch()
		}
		if (this.searchVal) {
			payload["searchVal"] = this.searchVal;
		}
		this.caseExcelLoader = true;
		this.apiService.getCasesExcel(payload).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.caseExcelLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = "Shorecare-Cases.xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.caseExcelLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	currentCaseObj: any = null;
	summaryLoader: any = null;
	getCaseSummary(caseObj: any) {
		this.currentCaseObj = null;
		this.summaryLoader = caseObj.id;
		this.apiService.getCaseSummary(caseObj.enc_id).subscribe({
			next: (response: any) => {
				this.summaryLoader = null;
				caseObj.summaryStr = response.replace(/\n/g, '<br />');
				this.currentCaseObj = JSON.parse(JSON.stringify(caseObj));
				$("#caseSummaryModalListPage").modal("show");
			}, error: (error) => {
				this.summaryLoader = null;
				this.currentCaseObj = null;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}
}
